var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTestSpeakingAi)?_c('mark-test-exam-ai',{attrs:{"uuid":_vm.uuid}}):(_vm.hasLoadedSchedule && _vm.hasLoadedSpeakingRubricVersion)?_c('assignment-grading-activities',{attrs:{"speaking-rubric-version":_vm.speakingRubricVersion}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }